export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-014.983d61a7.jpg";